import { connect, Dispatch } from 'react-redux';
import { listReviews } from '../../actions';
import { Store } from '../../store';
import { ReviewList, ReviewListActions, ReviewListAttributes } from './reviewList';

function mapStoreToAttributes(store: Store): ReviewListAttributes {
  return {
    reviews: store.reviews
  };
}

function mapDispatchToActions(dispatch: Dispatch<Store>): ReviewListActions {
  return {
      fetch: (done) => dispatch({...listReviews(), done})
  };
}

export default connect(mapStoreToAttributes, mapDispatchToActions)(ReviewList);
